export const store = {
  personalDesc: `Hello! I'm Ijeri Omitogun, a Software Engineer with a strong focus on creating user-friendly and visually engaging web applications. My journey started with a love for video games, which led me to discover my passion for web development. <br/> Over the years, I've worked on innovative projects at Nauticus Robotics and Google, honing my skills in designing intuitive user experiences and ensuring application performance and accessibility. <br/>
    While I specialize in frontend development, I'm always eager to explore new challenges in software engineering. If you're looking for someone to bring your vision to life, let's connect and create something extraordinary together.`,
  experiences: [
    {
      companyName: "University of Houston",
      startDate: "Aug 2015",
      endDate: "May 2019",
      jobTitle: "Bachelor of Science \n Computer Science",
      image: "uh.gif",
      thumbnail: "uhsc.jpg",
      companyUrl: "https://uh.edu/",
      description:
        "I developed front-end components with JavaScript and Vue.js for robotic control interfaces and contributed to UX design and automation for products like the Olympic Arm and Aquanaut. I assisted in offshore software deployments, conducted customer demos, and worked on the HaloGuard safety system to improve safety. I implemented an Automated User Testing Suite with Selenium in Git CI pipelines and maintained Python and Vue code repositories.",
    },
    {
      companyName: "Nauticus Robotics",
      startDate: "Feb 2019",
      endDate: "Jun 2021 ",
      jobTitle: "Software Engineer",
      image: "nauticus.gif",
      thumbnail: "aquanaut.webp",
      companyUrl: "https://nauticusrobotics.com/",
      description:
        "I developed front-end components with JavaScript and Vue.js for robotic control interfaces and contributed to UX design and automation for products like the Olympic Arm and Aquanaut. I assisted in offshore software deployments, conducted customer demos, and worked on the HaloGuard safety system to improve safety. I implemented an Automated User Testing Suite with Selenium in Git CI pipelines and maintained Python and Vue code repositories.",
    },
    {
      companyName: "Google LLC",
      startDate: " Nov 2021",
      endDate: " Mar 2024",
      jobTitle: "Software Engineer",
      image: "google-logo.png",
      thumbnail: "google-building.jpeg",
      companyUrl: "https://about.google/",
      description:
        "I developed front-end components with Angular, TypeScript, and Java, ensuring web accessibility compliance, and played a key role in designing and implementing Google's $5 billion Buying Hub. I led product epics, collaborated with cross-functional teams, and contributed to sub-projects like Supplier Nexus and Contracting Hub. I also trained contractors, mentored colleagues, and earned certifications in TypeScript, Angular, and Web Accessibility.",
    },
    {
      companyName: "Data Annotation",
      startDate: "Apr 2024",
      endDate: "Dec 2024",
      jobTitle: "AI Trainer (Contract)",
      image: "data-annotations-logo.jpg",
      thumbnail: "typing.png",
      companyUrl: "https://www.dataannotation.tech/",
      description:
        "I trained AI chatbots to enhance their coding capabilities and ensure high-quality code generation. I evaluated various coding problems to measure the AI’s progress and performance. I authored clear code snippets and explanations, and validated AI-generated code and images to meet project standards. My work involved ensuring correctness, performance, and alignment with project requirements.",
    },
  ],
  skills: {
    frontEndSkills: [
      "Angular",
      "Vue",
      "React",
      "TypeScript / Javascript",
      "HTML5",
      "SCSS/CSS",
      "Web Accessibility",
      "UX Design",
    ],
    backEndSkills: [
      "Python",
      "C#",
      "NoSQL",
      "ROS",
      "Node.js",
      "SQL",
      "REST",
      "OOP",
      // "System Design",
    ],
    devSkills: [
      "VS Code",
      "Jasmine",
      "Mocha/Chai",
      "Selenium",
      "Docker",
      "Unity3D",
      "Git",
      "Gitlab CI/CD",
    ],
  },
  endorsements: [
    {
      name: "Mayuri Raja",
      title: "Software Engineer at Google",
      imageSrc: "mayuri-profile-pic.jpeg",
      text: "Ijeri is hardworking and driven to solve even the toughest of problems. His curiosity and love of programming show in the quality and depth of his work.",
    },
    {
      name: "Blake DeBenon",
      title: "Senior Engineer at Google",
      imageSrc: "blake-profile-pic.jpeg",
      text: "I worked with Ijeri at Google on an ambitious project that led to billions in savings for Google. Ijeri made an enormous impact in helping the project succeed by working locking down and implementing requirements. Ijeri was an effective and reliable teammate. I would absolutely want to work with him again!",
    },
    {
      name: "Jide Akinyode",
      title: "VP of Engineering at Nauticus Robotics",
      imageSrc: "jide-profile-pic.jpeg",
      text: "Ijeri worked closely under me. He grew from a rookie intern to a full fledged engineer. He was a crucial part of launching several Nauticus Robotics products: Haloguard, Olympic Arm, and Aquanaut. He went above and beyond for the company. Any team would be lucky to have him",
    },
    {
      name: "Thanh Truong",
      title: "Software Engineer at Google",
      imageSrc: "thanh-profile-pic.jpeg",
      text: "Having worked closely with him for over two years, I’ve seen his technical expertise and positive attitude, particularly in leading and delivering UI features for our internal procurement platform. Ijeri is dependable, eager to learn, and actively contributes to improving our coding standards and team practices.",
    },
    {
      name: "John John",
      title: "Staff Engineer Manager at Google",
      imageSrc: "john-profile-pic.jpeg",
      text: "Ijeri was on my team at Google, where we built a centralized procurement platform. I appreciated his work ethic, positive attitude, and eagerness to learn. He collaborated well with other engineers and worked independently to fix bugs and clarify requirements with the business. His contributions helped us meet key milestones and launch on time. He would be an asset to any team.",
    },
  ],
  projects: [
    {
      title: "Buying Hub",
      companyName: "Google",
      category: "Enterprise",
      description:
        "Buying Hub consolidated Google's fragmented purchasing, contracts, supplier management, compliance, and risk workflows into one internal platform credited with approximately $5 billion in first-year savings.",
      workSummary:
        "I built Angular and TypeScript interfaces, Reactive Forms, NgRx state, REST integrations, and accessible experiences. For Supplier Nexus, I developed supplier search, results, information fields, compliance forms, and risk-management pages while collaborating across product, UX, business, and backend teams.",
      media: [
        "supplier-nexus-art.png",
        "buying_hub_nav.png",
        "find-a-supplier.png",
        "purchase_buying_hub.png",
      ],
      coverImg: "supplier-nexus-art.png",
      coverImgPos: "center",
      techStack: [
        "Angular",
        "TypeScript",
        "NgRx",
        "Reactive Forms",
        "Mocha",
        "Chai",
        "REST APIs",
        "WCAG",
      ],
      logo: "/assets/experience-images/google-logo.png",
      sortOrder: 1,
    },
    {
      title: "HCP Terraform",
      companyName: "HashiCorp at IBM",
      category: "Cloud",
      description:
        "HCP Terraform is the customer-facing application teams use to manage Terraform infrastructure, permissions, organizations, projects, and production workflows at enterprise scale.",
      workSummary:
        "I build full-stack Ember and Rails features spanning Flexible Permissions, Site Auditor, Effective Permissions, safer organization deletion and restoration, and authorization consistency. The work includes Pundit policies, REST APIs, automated testing, production on-call, reliability improvements, ADRs, and cross-team delivery.",
      media: [
        "TerraformGeneralSettings.png",
        "terraform.webp",
        "TerraformProjects.png",
      ],
      coverImg: "terraform.webp",
      url: "https://www.hashicorp.com/products/terraform",
      techStack: [
        "Ember.js",
        "Ruby on Rails",
        "Pundit",
        "REST APIs",
        "RSpec",
        "QUnit",
        "Playwright",
      ],
      logo: "/assets/clip-art-images/ibm-logo.svg",
      sortOrder: 2,
    },
    {
      title: "Olympic Arm",
      companyName: "Nauticus Robotics",
      category: "Robotics",
      description:
        "Olympic Arm is a seven-degree-of-freedom subsea robotic manipulator built for underwater drilling, pipeline repair, tool manipulation, and intervention.",
      workSummary:
        "I owned its tool-pickup and tool-changing behavior. Using Python and ROS, my software consumed position, geometry, and compatibility data from the perception system, then determined and controlled how the physical arm interacted with each tool.",
      media: ["olympic-arm.jpg", "oly-arm.gif"],
      coverImg: "olympic-arm.jpg",
      url: "https://nauticusrobotics.com/olympic-arm/",
      techStack: ["Vue.js", "ROS", "Python", "Docker"],
      logo: "/assets/experience-images/nauticus-logo.jpeg",
      sortOrder: 3,
    },
    {
      title: "HaloGuard",
      companyName: "Nauticus Robotics",
      category: "Robotics",
      description:
        "HaloGuard is an industrial personnel-safety system that uses Time-of-Flight cameras to track workers around heavy machinery and trigger safety stops in dangerous areas.",
      workSummary:
        "I developed the recording pipeline that captured camera data, processed images, synchronized eight feeds, and compiled them into a unified video. I also built the Vue playback page so users could review previous safety events.",
      media: ["haloguard.png"],
      coverImg: "haloguard.png",
      url: "https://www.rigzone.com/news/wire/transocean_deploys_drill_floor_safety_tech-12-feb-2021-164599-article/",
      techStack: ["Vue.js", "JavaScript", "ROS", "Python"],
      logo: "/assets/experience-images/nauticus-logo.jpeg",
      sortOrder: 4,
    },
    {
      title: "LAB",
      companyName: "Independent",
      category: "Games",
      description:
        "LAB is a 3D virtual chemistry laboratory designed to let students perform experiments without the cost or physical risks of a fully equipped lab.",
      workSummary:
        "I designed and built the simulation in Unity and C#, applying object-oriented design, 3D interaction, and UX principles to create a controlled educational environment.",
      media: ["LAB.png", "lab.gif"],
      coverImg: "LAB.png",
      url: "https://github.com/ijeriomit/LAB",
      techStack: ["C#", "Unity 3D"],
      logo: "/assets/clip-art-images/ijeri-logo-icon.png",
      sortOrder: 5,
    },
    {
      title: "Epoch",
      companyName: "Independent",
      category: "Games",
      description:
        "Epoch is a 2D side-scrolling RPG with customizable weapons, abilities, enemies, upgrades, and three playable levels.",
      workSummary:
        "I created the game in Unity and C#, building its combat, state management, progression, character equipment, enemies, coin upgrades, level flow, and animated interactions.",
      media: ["epoch.gif", "epoch-short.gif", "player-jumping.png"],
      coverImg: "epoch.gif",
      url: "https://github.com/ijeriomit/Epoch",
      techStack: ["C#", "Unity 3D"],
      logo: "/assets/clip-art-images/ijeri-logo-icon.png",
      sortOrder: 6,
    },
    {
      title: "React Portfolio",
      companyName: "Independent",
      category: "Personal",
      description:
        "This portfolio presents my engineering progression, case studies, services, and professional identity as one responsive interactive experience.",
      workSummary:
        "I designed and developed the current React version, including its component architecture, responsive layouts, accessible navigation, project storytelling, motion, deployment, and matrix-inspired visual system.",
      media: ["portfolio.png", "portfolio-2.png", "portfolio.gif"],
      coverImg: "portfolio.png",
      url: "https://github.com/ijeriomit/portfolio-site-3.0",
      techStack: ["React", "JavaScript", "SCSS", "HTML"],
      logo: "/assets/clip-art-images/ijeri-logo-icon.png",
      sortOrder: 7,
    },
  ],
};

export const RESUME_URL = "https://docs.google.com/document/d/e/2PACX-1vSVUipMvyjLoCQHtjjNIMTgP9k76EsOsacsX8mCDS8lTCU6zke-P5JzfH2sIpSkSg/pub";
